import React, { useState, useEffect } from 'react';

const ImageSlider = ({ images }) => {
  const [activePosition, setActivePosition] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActivePosition((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleSlideChange = (position) => {
    setActivePosition(position);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.touches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.touches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      setActivePosition((prev) => (prev + 1) % images.length);
    }
    if (touchStart - touchEnd < -50) {
      setActivePosition((prev) => (prev - 1 + images.length) % images.length);
    }
    setTouchStart(0);
    setTouchEnd(0);
  };

  return (
    <div className="w-full">
      <div
        className="relative w-full h-[200px] md:h-[400px] overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="flex transition-transform duration-500"
          style={{ transform: `translateX(-${activePosition * 100}%)` }}
        >
          {images.map((image, index) => (
            <div key={index} className="min-w-full flex items-center justify-center">
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="md:w-400 md:h-[390px] w-200 h-[200px] "
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center mt-4 space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => handleSlideChange(index)}
            className={`w-4 h-4 border-2 rounded-full ${
              activePosition === index
                ? 'bg-white border-gray-300'
                : 'bg-red-500 border-gray-400'
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default ImageSlider;
